// extracted by mini-css-extract-plugin
export default {"statusTag":"ucWjE_","collecting-votes":"zDoKOJ","collectingVotes":"zDoKOJ","released":"MdxPYM"};